//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Button, TextField } from '@mui/material';
import { FormHelperText } from '@mui/material';
import { IconButton } from '@mui/material';
import { InputAdornment } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { VisibilityOff } from '@mui/icons-material';
//  -- Components ---------------------
import { Col, Row } from 'antd';
import Loading from 'components/Loading';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
//  -- Thunks -------------------------
import { handleForcePasswordChange } from 'store/users/thunks';
import styled from 'styled-components';
//  -- Constants ----------------------
import COLOR from 'utils/constants/color';






//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 48px;
`;

const Header = styled(Description)`
    color: ${COLOR.black100};
    font-size: 28px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 16px;
`;

const Wrapper = styled.form`
    margin: 0px auto;
    max-width: 480px;
    width: 100%;
`;


//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Change password form
//
//  -- Description
//  Change password
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const ChangePasswordForm = ({
    userData,
    loading,
    onClosed
}) => {
    const dispatch = useDispatch();
    const [data, setData] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordNew, setShowPasswordNew] = useState(false);
    const [matchError, setMatchError] = useState(false);
    const [formatPasswordError, setFormatPasswordError] = useState(false);
    const [passLoader, setPassLoader] = useState(false);

    const handleChange = e => {
        setData({
            ...data,
            [e.target.id]: e.target.value
        });
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
      };
      
    const handleClickShowPasswordNew = () => {
        setShowPasswordNew(!showPasswordNew);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!verifyPassword(data.password)) {
            setFormatPasswordError(true);
            setMatchError(false);
            return;
        }
        if (data.password !== data.newpassword) {
            setMatchError(true);
            setFormatPasswordError(false);
            return;
        }
        setFormatPasswordError(false);
        setMatchError(false);
    
        let upPsw = {
            username: userData.username,
            password: data.password,
        };
        setPassLoader(true);
        await dispatch(handleForcePasswordChange(upPsw));
        setPassLoader(false);
        onClosed();
    };    

    function verifyPassword(password){
        var paswd = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
        if(password.match(paswd)) 
        {
            setFormatPasswordError(false);
            return true;
        }else
        { 
            setFormatPasswordError(true);
            return false;
        }
    }

    return (
        <Wrapper onSubmit={onSubmit}>
            <Header>Change Password User: {userData.firstName} {userData.lastName}</Header>
            <Description>Please use 8 to 15 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit and one special character.</Description>
            <Row gutter={[24, 24]} style={{ width: '100%', display:"flex", alignItems:"center", justifyContent:"center" }}>
                    <Col span={12} className='gradPasswordSection'>
                    <TextField
                        id="password"
                        variant="outlined"
                        type={showPassword ? 'text' : 'password'}
                        label="Password"
                        value={data?.password}
                        onChange={handleChange}
                        InputProps={{
                            endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                aria-label="Toggle password visibility"
                                onClick={handleClickShowPassword}
                                >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                            ),
                        }}
                        />
                    </Col>
                    <Col span={12} className='gradPasswordSection'>
                    <TextField
                        id="newpassword"
                        variant="outlined"
                        type={showPasswordNew ? 'text' : 'password'}
                        label="Confirm password"
                        value={data?.newpassword}
                        onChange={handleChange}
                        InputProps={{
                            endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                aria-label="Toggle password visibility"
                                onClick={handleClickShowPasswordNew}
                                >
                                {showPasswordNew ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                            ),
                        }}
                        />
                    </Col>
                    <Col>
                    { formatPasswordError &&
                            <FormHelperText error>The password does not match the above mentioned criteria.</FormHelperText>
                        }
                    </Col>
                    <Col>
                    { matchError &&
                            <FormHelperText error>The password and confirm password must be the same.</FormHelperText>
                        }
                    </Col>
                </Row>
            <Row gutter={[24, 24]} style={{ width: '100%'}}>
                <Col span={24}>
                    <Button
                        disabled={!(data.password && data.newpassword)}
                        variant="contained"
                        color="primary"
                        style={{ width: '100%' }}
                        type='submit'
                    >
                        {passLoader && <Loading size={20} white />} {'Update password'}
                    </Button>
                </Col>
            </Row>
        </Wrapper>
    );
};


export default ChangePasswordForm;